<template>
    <div :class="[pure ? 'account-menu mobile-helper' : 'bg-white account-menu overflow-auto', {'rounded-lg': $vuetify.display.lgAndUp}]">
        <v-container class="pa-3">
            <v-row class="pa-0">
                <v-col :cols="$vuetify.display.smAndDown ? 12:6" :class="{
                                    'pa-8 pb-12': $vuetify.display.mdAndUp,
                                    'pa-5': $vuetify.display.smAndDown
                                }">
                    <v-form
                        id="login-form"
                        v-model="validLogin"
                        @submit.prevent="loginSubmit"
                        lazy-validation
                        ref="loginForm"
                    >
                        <p class="text-h6 font-weight-bold mb-5">{{$t('login-btn.login')}}</p>
                        <p class="font-weight-bold text-body-3 mb-2">{{$t('login-btn.email')}} </p>
                        <v-text-field :error="!!$page.props.errors.login?.email"
                                      :error-messages="$page.props.errors.login?.email"
                                      @keyup.enter="loginSubmit"
                                      autocomplete="email"
                                      v-model="loginFormItems.email" density="compact" class="mb-0" :height="48" type="email" variant="outlined" :placeholder="$t('login-btn.placeholder_email')"></v-text-field>
                        <div class="d-flex justify-space-between mb-2">
                            <p class="font-weight-bold text-body-3">{{$t('login-btn.password')}}</p>
                            <div @click="go(route('password.request'))" class="text-decoration-underline tooltip-activator">{{$t('login-btn.lost_password')}}</div>
                        </div>
                        <v-text-field :error="!!$page.props.errors.login?.password"
                                      :error-messages="$page.props.errors.login?.password"
                                      @keyup.enter="loginSubmit"
                                      autocomplete="password"
                                      @click:append-inner="showPassword = !showPassword"
                                      :append-inner-icon="showPassword ? mdiEyeOffOutline : mdiEyeOutline"
                                      v-model="loginFormItems.password" :type="showPassword ? 'text' : 'password'" persistent-hint density="compact" :height="48" variant="outlined" :placeholder="$t('login-btn.password')"></v-text-field>
                        <v-btn type="submit" :loading="loading" id="login-form_submit" color="orange" block class="text-body-1 text-white font-weight-bold" elevation="0" :height="48">{{$t('login-btn.login')}}</v-btn>
                    </v-form>
                </v-col>
                <v-divider vertical v-show="!$vuetify.display.smAndDown"></v-divider>
                <v-col class="pa-0" :cols="$vuetify.display.smAndDown ? 12:6">
                    <div :class="{
                                    'pa-8 pb-12': $vuetify.display.mdAndUp,
                                    'pa-5': $vuetify.display.smAndDown
                                }">
                        <p class="text-h6 font-weight-bold" :class="{
                                        'text-center mb-2': $vuetify.display.smAndDown,
                                        'mb-5': $vuetify.display.mdAndUp
                                    }">
                            {{$t('login-btn.still_no_account')}}
                        </p>
                        <p class="text-body-3 font-weight-light text-grey mb-7" :class="{
                                        'text-center': $vuetify.display.smAndDown
                                    }">
                            {{$t('login-btn.become_dealer')}}<span v-if="false" class="text-orange text-decoration-underline cursor-pointer">{{$t('login-btn.more_about_dealer_account')}}</span>
                        </p>
                        <v-btn color="green" block class="text-body-1 text-white font-weight-bold" elevation="0" :height="48" @click="go(route('register.view'))" id="register-btn">{{$t('login-btn.register')}}</v-btn>
                    </div>
                    <div class="backgrounds" v-show="$vuetify.display.mdAndUp">
                        <div class="b1"></div>
                        <div class="b2"></div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script setup>
import {inject, ref} from "vue";
import {router, usePage} from "@inertiajs/vue3";
import {mdiEyeOff, mdiEyeOffOutline, mdiEyeOutline} from "@mdi/js";
const loginForm = ref(null);
const validLogin = ref(true);
const route = inject('route');
const loading = ref(false);
const emit = defineEmits(['closeMenu', 'beginLogin']);
const loginFormItems = ref({
    email: "",
    password: "",
    remember: false
});
const props = defineProps({
   pure: {
       type: Boolean,
       default: false
   }
});
const loginSubmit = () => {
    loading.value = true;
    emit('beginLogin');
    // eslint-disable-next-line no-undef
    router.post(route('customer.login'), loginFormItems.value, {
        errorBag: 'login',
        onSuccess: (resp) => {
            emit('closeMenu');
            delete usePage().props.errors.registration;
            delete usePage().props.errors.login;
            loading.value = false;
        },
        onError: () => {
            if(!props.pure)
                usePage().props.openLogin = true;
            loginForm.value.validate();
            loading.value = false;
        }
    });
};
const showPassword = ref(false);
const go = (where) => {
    router.visit(where);
    emit('closeMenu')
}
</script>
<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
.account-menu {
    width: 670px;
    @media #{map.get($display-breakpoints, 'sm-and-down')}{
        &:not(.mobile-helper) {
            width: calc(100vw - 24px);
            top: 34px;
            position:fixed;
        }
    }
    &.mobile-helper {
        width: unset;
    }
}
.backgrounds {
    height: 90px;
    width: 100%;
    position: relative;

    .b1 {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url(../../../assets/images/common/mshort.svg);
        background-size: contain;
        background-position: bottom center
    }

    .b2 {
        position: absolute;
        width: 100%;
        margin-top: -70px;
        height: calc(100% + 70px);
        pointer-events: none;
        background-image: url(../../../assets/images/login/thinking.png);
        background-size: contain;
        background-position: bottom center
    }
}
</style>
